import React from 'react';

import {RowItemAdornmentView} from './RowItemAdornment.styles';

import type {RowItemAdornmentProps} from './_types';

export const RowItemAdornment = ({
  children,
  isInteractive,
}: RowItemAdornmentProps) => {
  /**
   * We turn off pointer-events at the portal wrapper layer because the existence of the Chevron causes the wrapper to have a non-zero size and block clicks.
   * We need to turn pointer-events back on if children are interactive.
   */
  return (
    <RowItemAdornmentView isInteractive={isInteractive} spacing={1}>
      {children}
    </RowItemAdornmentView>
  );
};

RowItemAdornment.displayName = 'RowItemAdornment';
RowItemAdornment.toString = RowItemAdornmentView.toString;
